module.exports = __webpack_public_path__ + "c2ba39152480e762b43452159e39825f.woff2";


//////////////////
// WEBPACK FOOTER
// ./libs/font-awesome/webfonts/fa-brands-400.woff2
// module id = 344
// module chunks = 0